import { SortingRule } from 'react-table';
import URL_PARAMS, {
  DataTableURLParamKeys,
} from 'components/v2/DataTable/data/urlParams';
import { SortingDirection } from 'components/v2/DataTable/helpers/getSortingDirection';

const getSortingParamsFromURL = (
  paramKeys: Pick<DataTableURLParamKeys, 'sortId' | 'sorting'> = URL_PARAMS,
  search = window.location.search
): SortingRule<string> => {
  const searchParams = new URLSearchParams(search);
  const sortId = searchParams.get(paramKeys.sortId) ?? '';
  const sortDirection = searchParams.get(paramKeys.sorting);

  if (
    !sortId ||
    (sortDirection !== SortingDirection.asc &&
      sortDirection !== SortingDirection.desc)
  ) {
    return {
      id: '',
    };
  }

  return {
    id: sortId,
    desc: sortDirection === SortingDirection.desc,
  };
};
export default getSortingParamsFromURL;
